module.exports = __webpack_public_path__ + "img/chineseBrandImg.d7b09c43.png";